import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { getLink } from "../../dataProvider/links.js";
import { addCloudFile, getCloudFiles } from '../../actions/file.js'
import useWindowDimensions from "../util/Window.js"
import CloudFile from "./CloudFile.jsx";
import moment from 'moment'
import '../../scss/v2/user/cloud.scss'

function Cloud(props) {

    const { t, i18n } = useTranslation();
    const { width } = useWindowDimensions();
    const [alertSuccess, setAlertSuccess] = useState(false);
    const [filter, setFilter] = useState('latest');
    const [files, setFiles] = useState([]);
    const [error, setError] = useState()
    const [reloadCount, setReloadCount] = useState(0)
    let navigate = useNavigate();

    const hiddenFileInput = useRef(null);

    const reloadFiles = useCallback(async () => {
        const files = await props.dispatch(getCloudFiles());
        setFiles(files)
    }, [props])

    useEffect(() => {
        if (!props.user || !props.user.connected) return navigate(getLink('login', i18n.language));
        i18n.changeLanguage(props.lang)
    }, [props])

    useEffect(() => {

        let intervalMs = 60000;
        if (reloadCount < 20) intervalMs = 10000
        if (reloadCount < 10) intervalMs = 5000
        if (reloadCount < 5) intervalMs = 1000
        if (reloadCount < 2) intervalMs = 500

        const interval = setInterval(() => {
            reloadFiles();
            setReloadCount(reloadCount + 1)
        }, intervalMs)

        return () => {
            clearInterval(interval)
        }

    }, [reloadCount])

    async function uploadFileHandler(event) {
        const file = event.target.files[0]
        if (file.size + props.cloud.usage > props.cloud.maxUsage.value) return setError(t('cloud.error.maxSize', { maxSize: props.cloud.maxUsage.label }))
        await props.dispatch(addCloudFile(file))
        setAlertSuccess(true)
        startAlertTimer()
        event.target.value = null;
        reloadFiles()
    }

    const uploadFileButtonHandler = () => hiddenFileInput.current.click();

    const startAlertTimer = () => {
        setTimeout(() => {
            setAlertSuccess(false)
        }, 15000);
    }

    const getFileType = (fileToProcess) => {
        return fileToProcess.name.split('.')[fileToProcess.name.split('.').length - 1].toUpperCase()
    }

    const sortingFunction = (fileA, fileB) => {
        if (filter === "name") {
            if (fileA.name < fileB.name) { return -1; }
            if (fileA.name > fileB.name) { return 1; }
            return 0;
        } else if (filter === "filetype") {
            const filetypeA = getFileType(fileA);
            const filetypeB = getFileType(fileB);
            if (filetypeA < filetypeB) { return -1; }
            if (filetypeA > filetypeB) { return 1; }
            return 0;
        } else {
            return moment(fileB.date).diff(fileA.date)
        }
    }

    const renderHead = () => {
        if (width < 900) {
            return (
                <>
                    <tr>
                        <th className="py-1">{t("cloud.table.title.name")}</th>
                        <th></th>
                    </tr>
                </>
            )
        }
        return (
            <tr>
                <th>{t("cloud.table.title.name")}</th>
                <th>{t("cloud.table.title.time")}</th>
                <th>{t("cloud.table.title.convert")}</th>
                <th>{t("cloud.table.title.status")}</th>
                <th></th>
            </tr>
        )
    }

    const renderAlert = () => {
        if (!alertSuccess) return;
        return (
            <div className="alert alert-success alert-container">
                {t('cloud.alert.upload.success')}
                <span className="alert-close" onClick={() => { setAlertSuccess(false) }}>x</span>
            </div>
        )
    }

    return (
        <div className="cloud container">
            <div className="row">
                <div className="col-12 col-lg-10 offset-lg-1">
                    <div className="cloud-header-container">
                        <h1 className="cloud-title">{t('cloud.title')}</h1>
                        {props.subscription.subscribed && (
                            <>
                                <button className="button cloud-upload-button" onClick={uploadFileButtonHandler}>{t('cloud.upload.button')}</button>
                                <input type="file" name="file" ref={hiddenFileInput} onChange={uploadFileHandler} style={{ display: 'none' }} />
                            </>
                        )}
                        <Dropdown className="d-block d-lg-inline-block">
                            <Dropdown.Toggle id="dropdown-filter">
                                <span className="dropdown-filter-text">{t('cloud.filter.text')}</span>
                                {" "}
                                <span className="dropdown-filter-mode">{t(`cloud.filter.${filter}`)}</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu align="right">
                                <Dropdown.Item onClick={() => { setFilter("latest") }}>{t('cloud.filter.latest')}</Dropdown.Item>
                                <Dropdown.Item onClick={() => { setFilter("name") }}>{t('cloud.filter.name')}</Dropdown.Item>
                                <Dropdown.Item onClick={() => { setFilter("filetype") }}>{t('cloud.filter.filetype')}</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <div className="col-12">
                        {renderAlert()}
                        <p className="cloud-subtitle">{t('cloud.subtitle')}</p>
                        {error && (
                            <div className="alert alert-danger alert-container">
                                {error}
                                <span className="alert-close" onClick={() => { setError(null) }}>x</span>
                            </div>
                        )}
                        <div className="cloud-file-container">
                            <div className="table-responsive-lg">
                                <table className="table cloud-file-table">
                                    <thead>
                                        {renderHead()}
                                    </thead>
                                    <tbody>
                                        {files.sort(sortingFunction).map((file, index) => (<CloudFile file={file} index={index} key={index} />))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

const mapStateToProps = state => ({ user: state.user.user, file: state.file, cloud: state.user.cloud, subscription: state.user.subscription })

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(Cloud);